<script setup lang="ts">
import { cn } from "@/lib/utils";
import { ArrowLeft } from "lucide-vue-next";

import { DialogClose } from "radix-vue";
interface DialogGoBackProps {
    class?: string;
}

const props = defineProps<DialogGoBackProps>();
</script>

<template>
    <div :class="cn('border-iron-200 px-6 py-4 border-b', props.class)">
        <DialogClose class="gap-1 flex">
            <ArrowLeft :size="20" class="text-z-primary-600"></ArrowLeft>
            <p class="text-sm font-medium text-z-primary-600">
                {{ $t("go_back") }}
            </p>
        </DialogClose>
    </div>
</template>
